import { sample } from 'lodash';
import Configs from '../../../../configs/Configs';
import Enemy from '../../enemy/Enemy';
import Cooldown from '../cooldown/Cooldown';
import { $playerProfile, getAliceDamage, getAliceCritChance } from '../../../../backend/store/playerProfile';
import { $playerConfig } from '../../../../backend/store/playerConfig';

const COOLDOWN = {
    X: 0,
    Y: 150,
};

const EVENTS = {};

const ANIMS = {
    ATTACK: 'Attack',
    ATTACK1: 'Attack1',
    ATTACK1_1: 'Attack1.1',
    ATTACK2: 'Attack2',
    ATTACK2_IDLE: 'Attack2_Idle',
    ATTACK3: 'Attack3',
    IDLE: 'Idle',
    SWAP: 'Swap',
    SWAP2: 'Swap2',
};

const SWAP = {
    DURATION: 250,
    EASE: {
        IN: Phaser.Math.Easing.Back.Out,
        OUT: Phaser.Math.Easing.Back.In,
    },
};

export default class Hero extends Phaser.GameObjects.Container {
    private config: any;
    public selected: boolean;
    private lastHitTimer?: Phaser.Time.TimerEvent;
    private tweenSwap?: Phaser.Tweens.Tween;
    private baseX: number;
    private sprite!: any;
    private cooldown!: Cooldown;

    constructor(scene: Phaser.Scene, x: number, y: number, config: any) {
        super(scene, x, y);

        this.config = config;
        this.selected = false;
        this.baseX = x;

        this.setupSprite();
        this.setupCooldown();
        this.setupListeners();
        this.deselect();
    }

    static get EVENTS() {
        return EVENTS;
    }

    setupSprite() {
        let spine = this.id === 0 ? 'Alice' : 'Bob';

        this.sprite = this.scene.add.spine(0, 0, spine, ANIMS.IDLE, true);
        this.add(this.sprite);

        if (this.id === 0) this.sprite.setScale(0.4);
        if (this.id === 1) this.sprite.setScale(0.5);

        // this.sprite.setMix(ANIMS.ATTACK1, ANIMS.IDLE, 0.3);
        // this.sprite.setMix(ANIMS.IDLE, ANIMS.ATTACK1, 0.3);
    }

    setupCooldown() {
        let x = COOLDOWN.X;
        let y = COOLDOWN.Y;

        this.cooldown = new Cooldown(this.scene, x, y);
        this.add(this.cooldown);
    }

    setupListeners() {
        this.scene.events.on(Enemy.EVENTS.DAMAGED, this.onEnemyDamaged, this);
    }

    onEnemyDamaged(x: number, y: number, damage: number, isCrit: boolean, isEnrageHit: boolean, heroId: number) {
        if (this.id !== heroId) return;
        this.sprite.off('complete', this.setIdleAnim, this);

        let anim = this.id === 0 ? sample([ANIMS.ATTACK1, ANIMS.ATTACK1_1]) : ANIMS.ATTACK;

        this.sprite.play(anim, false);
        this.sprite.once('complete', this.setIdleAnim, this);
        // this.sprite.once('complete', () => this.sprite.play(ANIMS.IDLE, true));
    }

    setIdleAnim(): void {
        this.sprite.play(ANIMS.IDLE, true);
    }

    select() {
        this.showSwapIn();
        this.selected = true;
    }

    deselect() {
        this.showSwapOut();
        this.selected = false;
        // this.sprite.setAlpha(0.5);
    }

    showSwapIn() {
        this.tweenSwap?.remove();

        let dist = this.scene.cameras.main.width;
        let direction = this.id === 0 ? 1 : -1;

        // console.log(this.id, this.baseX);
        let from = this.id === 0 ? this.baseX : this.baseX + dist;
        let to = from + dist * direction;

        this.tweenSwap = this.scene.tweens.add({
            targets: this,
            x: { from, to },
            duration: SWAP.DURATION,
            ease: SWAP.EASE.IN,
        });
    }

    showSwapOut() {
        this.tweenSwap?.remove();

        let dist = this.scene.cameras.main.width;
        let direction = this.id === 0 ? -1 : 1;

        let from = this.id === 0 ? this.baseX + this.scene.cameras.main.width : this.baseX;
        let to = from + dist * direction;

        this.tweenSwap = this.scene.tweens.add({
            targets: this,
            x: { from, to },
            duration: SWAP.DURATION,
            ease: SWAP.EASE.OUT,
        });
    }

    attack() {
        this.lastHitTimer = this.scene.time.addEvent({ delay: this.attackSpeed });
        this.cooldown.start(this.attackSpeed);
    }

    get damage() {
        // return { damage: 500, isCrit: false };

        let damage = 0;
        let isCrit = false;
        let playerConfig = $playerConfig.getState();

        if (this.heroName === Configs.HEROES.ALICE) {
            let alice = $playerProfile.getState().hero_alice;

            let baseDamage = getAliceDamage().attack!;
            let critChance = getAliceCritChance().value!;

            isCrit = Math.random() <= critChance;
            damage = isCrit
                ? baseDamage * $playerConfig.getState().base_values.alice_crit_chance_multiplication
                : baseDamage;
        } else {
            let bob = $playerProfile.getState().hero_bob;

            let baseDamage = playerConfig.bob.damage_level[bob.damage_level].level_value;

            damage = baseDamage;
        }

        return { damage, isCrit };
    }

    get id() {
        return this.config.id;
    }

    get canAttack() {
        if (!this.lastHitTimer) return true;
        return this.lastHitTimer.getOverallRemaining() === 0;
        // let time = Date.now() - this.lastHitTime;
        // return time >= this.attackSpeed;
    }

    get level() {
        return this.config.level;
    }

    get attackSpeed() {
        return this.config.attackSpeed * 1000;
    }

    get heroName() {
        let name = this.id === 0 ? Configs.HEROES.ALICE : Configs.HEROES.BOB;
        return name;
    }

    destroy() {
        this.lastHitTimer?.remove();
        super.destroy();
    }
}
